import {captureException} from '@zzng/common/utils/matrix';
import {isTalkScheme} from '@zzng/common/utils/scheme';

// 앱스킴 파라미터에 target이 있는지 판단
// ex. kakaotalk://digitalcard/open?url={URL}&target=_blank => true
// ex. kakaotalk://digitalcard/open?url={URL}&target=blank => false
// ex. kakaotalk://digitalcard/open?url={URL}&target=_self => false
const hasTarget = (schemeUrl: string) => {
  try {
    const url = new URL(schemeUrl);
    return url.searchParams.get('target') === '_blank';
  } catch {
    return false;
  }
};

export const checkValidSchemeUrl = (schemeUrl: string) => {
  if (isTalkScheme(schemeUrl, 'DIGITAL_CARD') && !hasTarget(schemeUrl)) {
    const msg = `target이 없거나 값이 _blank가 아닙니다. schemeUrl: ${schemeUrl}`;
    captureException(msg);
  }
};

/** 스킴 파라미터 중 URL 파라미터 추출하는 함수 */
export const extractUrlSchemeParam = (schemeUrl: string) => {
  try {
    const url = new URL(schemeUrl);
    const urlParams = url.searchParams.get('url');

    if (!urlParams) {
      captureException(`스킴 url 파라미터가 없습니다. shcemeUrl: ${schemeUrl}`);
      return '';
    }

    // 이중 인코딩 처리를 위한 디코딩
    return decodeURIComponent(urlParams);
  } catch (e) {
    captureException(`스킴 url 파라미터 추출 실패: ${e}`);
    return '';
  }
};
